module.exports = __webpack_public_path__ + "img/icon_linkpfeil-blau_links.21b10dde.svg";